<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Estabalecimentos"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "estabelecimentoTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "estabelecimento_id",
        "estabelecimento_nome",
        "descricao_estabelecimento",
        "actions",
      ],
      tableData: [
        "estabelecimento_id",
        "estabelecimento_nome",
        "descricao_estabelecimento",
        "endereco",
        "bairro",
        "complemento",
        "cep",
        "ponto_referencia",
        "telefone",
        "cnes",
        "situacao_estabelecimento",
        "data_registro",
        "numero",
        "municipio_id",
        "tipo_estabelecimento_id",
        "estado_id",
        "unidade_saude_id",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["estabelecimento_id", "estabelecimento_nome"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          estabelecimento_id: "ID",
          estabelecimento_nome: "Nome do Estabelecimento",
          descricao_estabelecimento: "Descrição do Estabelecimento",
          actions: "Ações",
        },
        sortable: ["estabelecimento_id", "estabelecimento_nome", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "estabelecimento",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        estabelecimento_id: "estabelecimento_id",
        estabelecimento_nome: "estabelecimento_nome",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>